module.exports = __webpack_public_path__ + "img/code_586F726E656C697573.a02f9f5a.svg";